// Import React
import React, {Fragment} from "react";

const About = () => {
	return(
        <Fragment>
	  <h1>About</h1>
	  Texto Sobre la empresa.
	</Fragment>
    );
    
};

export default About;